"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ExerciseEntryState = (_class = /*#__PURE__*/function (_RootState) {
  function ExerciseEntryState(exerciseEntry) {
    var _this;
    _classCallCheck(this, ExerciseEntryState);
    _this = _callSuper(this, ExerciseEntryState);
    _initializerDefineProperty(_this, "assignedExerciseEntry", _descriptor, _this);
    _initializerDefineProperty(_this, "blankValueFilledIn", _descriptor2, _this);
    _initializerDefineProperty(_this, "revealed", _descriptor3, _this);
    _initializerDefineProperty(_this, "assigned", _descriptor4, _this);
    _initializerDefineProperty(_this, "submittedValue", _descriptor5, _this);
    _initializerDefineProperty(_this, "exercise", _descriptor6, _this);
    _initializerDefineProperty(_this, "incorrectCasing", _descriptor7, _this);
    _initializerDefineProperty(_this, "incorrectSpecialCharacters", _descriptor8, _this);
    _initializerDefineProperty(_this, "incorrectPunctuation", _descriptor9, _this);
    _initializerDefineProperty(_this, "incorrectCasingSubmittedValues", _descriptor0, _this);
    _initializerDefineProperty(_this, "incorrectSpecialCharactersSubmittedValues", _descriptor1, _this);
    _initializerDefineProperty(_this, "incorrectPunctuationSubmittedValues", _descriptor10, _this);
    _this.exerciseEntry = exerciseEntry;
    return _this;
  }
  _inherits(ExerciseEntryState, _RootState);
  return _createClass(ExerciseEntryState, [{
    key: "correct",
    get: function get() {
      return !this.blankValueFilledIn && this.submissionMatches;
    }
  }, {
    key: "submissionMatches",
    get: function get() {
      return this.assignedExerciseEntryMatches || this.submittedValueMatchesSentence || this.allSelectedWordsCorrect || this.allWordsCorrect || this.submittedValueMatchesMediaOption || this.submittedValueMatchesMultipleChoiceOption;
    }
  }, {
    key: "submittedValueMatchesMediaOption",
    get: function get() {
      var _this2 = this;
      if (this.exerciseEntry.selectAllCorrectOptions && this.exerciseEntry.hasMediaOptions) {
        return (0, _lodash.every)(this.exerciseEntry.mediaOptions.map(function (item) {
          var _this2$submittedValue, _this2$submittedValue2;
          return ((_this2$submittedValue = _this2.submittedValue) === null || _this2$submittedValue === void 0 ? void 0 : _this2$submittedValue.includes(item.id)) && item.selected || !((_this2$submittedValue2 = _this2.submittedValue) !== null && _this2$submittedValue2 !== void 0 && _this2$submittedValue2.includes(item.id)) && !item.selected;
        }));
      }
      return (0, _utils.isPresent)(this.exerciseEntry.mediaOptions.find(function (item) {
        return item.id === _this2.submittedValue && item.selected;
      }));
    }
  }, {
    key: "submittedValueMatchesMultipleChoiceOption",
    get: function get() {
      var _this3 = this;
      if (this.exerciseEntry.selectAllCorrectOptions && (0, _utils.isPresent)(this.exerciseEntry.multipleChoiceOptions)) {
        return (0, _lodash.every)(this.exerciseEntry.multipleChoiceOptions.map(function (item) {
          var _this3$submittedValue, _this3$submittedValue2;
          return ((_this3$submittedValue = _this3.submittedValue) === null || _this3$submittedValue === void 0 ? void 0 : _this3$submittedValue.includes(item.id)) && item.correct || !((_this3$submittedValue2 = _this3.submittedValue) !== null && _this3$submittedValue2 !== void 0 && _this3$submittedValue2.includes(item.id)) && !item.correct;
        }));
      }
      return (0, _utils.isPresent)(this.exerciseEntry.multipleChoiceOptions.find(function (item) {
        return item.id === _this3.submittedValue && item.correct;
      }));
    }
  }, {
    key: "allSelectedWordsCorrect",
    get: function get() {
      return this.exerciseEntry.hasSentence && this.exercise && !this.exercise.exerciseType.evaluateEntireSentence && this.exerciseEntry.sentence.allSelectedWordsCorrect;
    }
  }, {
    key: "allWordsCorrect",
    get: function get() {
      return this.exerciseEntry.hasSentence && this.exercise && this.exercise.exerciseType.evaluateEntireSentence && this.exerciseEntry.sentence.allWordsCorrect;
    }
  }, {
    key: "submittedValueMatchesAlternateText",
    get: function get() {
      return this.exerciseEntry.hasSentence && this.exercise && (0, _lodash.some)(this.exerciseEntry.sentence.selectedWordAssociations.map(function (item) {
        return item.state.submittedValueMatchesAlternateText();
      }));
    }
  }, {
    key: "normalizedSentenceTargetText",
    get: function get() {
      return (0, _utils.normalizeCharacters)(this.exerciseEntry.sentence.targetText);
    }
  }, {
    key: "normalizedSubmittedValue",
    get: function get() {
      if ((0, _lodash.isString)(this.submittedValue)) {
        return (0, _utils.normalizeCharacters)(this.submittedValue);
      }
    }
  }, {
    key: "submittedValueMatchesSentence",
    get: function get() {
      return this.exerciseEntry.hasSentence && (0, _utils.isPresent)(this.submittedValue) && (0, _utils.sameWithoutCaseAccentsAndPunctuation)(this.normalizedSubmittedValue, this.normalizedSentenceTargetText);
    }
  }, {
    key: "assignedExerciseEntryMatches",
    get: function get() {
      return (0, _utils.isPresent)(this.assignedExerciseEntry) && (0, _lodash.lowerCase)(this.assignedExerciseEntry.prompt) === (0, _lodash.lowerCase)(this.exerciseEntry.prompt);
    }
  }, {
    key: "assignedExerciseEntryPrompt",
    get: function get() {
      return (0, _utils.isPresent)(this.assignedExerciseEntry) ? this.assignedExerciseEntry.prompt : null;
    }
  }, {
    key: "entryHasUserInput",
    get: function get() {
      return !this.blankValueFilledIn && ((0, _utils.isPresent)(this.submittedValue) || (0, _utils.isPresent)(this.assignedExerciseEntry) || this.wordsHaveUserInput);
    }
  }, {
    key: "wordsHaveUserInput",
    get: function get() {
      return this.exerciseEntry.sentence && (0, _utils.isPresent)(this.exerciseEntry.sentence.wordAssociations.find(function (item) {
        return item.state.entryHasUserInput;
      }));
    }
  }, {
    key: "incorrectCasingSubmittedValue",
    get: function get() {
      return this.incorrectCasingSubmittedValues.join(', ');
    }
  }, {
    key: "incorrectSpecialCharactersSubmittedValue",
    get: function get() {
      return this.incorrectSpecialCharactersSubmittedValues.join(', ');
    }
  }, {
    key: "incorrectPunctuationSubmittedValue",
    get: function get() {
      return this.incorrectPunctuationSubmittedValues.join(', ');
    }
  }, {
    key: "evaluate",
    value: function evaluate(exercise, params) {
      var _this4 = this;
      this.exercise = exercise;
      this.incorrectCasingSubmittedValues = [];
      this.incorrectSpecialCharactersSubmittedValues = [];
      this.incorrectPunctuationSubmittedValues = [];
      if (this.exerciseEntry.hasSentence) {
        if ((0, _utils.isPresent)(this.exerciseEntry.sentence.selectedWordAssociations)) {
          (0, _lodash.each)(this.exerciseEntry.sentence.selectedWordAssociations, function (item) {
            item.state.evaluate(params, exercise);
            if (item.state.incorrectCasing) {
              _this4.incorrectCasing = true;
              _this4.incorrectCasingSubmittedValues.push(item.state.submittedValue);
            }
            if (item.state.incorrectSpecialCharacters) {
              _this4.incorrectSpecialCharacters = true;
              _this4.incorrectSpecialCharactersSubmittedValues.push(item.state.submittedValue);
            }
            if (item.state.incorrectPunctuation) {
              _this4.incorrectPunctuation = true;
              _this4.incorrectPunctuationSubmittedValues.push(item.state.submittedValue);
            }
          });
        } else if ((0, _utils.isPresent)(this.submittedValue) && (0, _utils.isPresent)(this.exerciseEntry.sentence.targetText)) {
          var _compareSubmittedValu = (0, _utils.compareSubmittedValueWithSolution)(this.normalizedSubmittedValue, this.normalizedSentenceTargetText),
            incorrectCasing = _compareSubmittedValu.incorrectCasing,
            incorrectSpecialCharacters = _compareSubmittedValu.incorrectSpecialCharacters,
            incorrectPunctuation = _compareSubmittedValu.incorrectPunctuation;
          this.incorrectCasing = incorrectCasing;
          this.incorrectSpecialCharacters = incorrectSpecialCharacters;
          this.incorrectPunctuation = incorrectPunctuation;
          if (this.incorrectCasing) {
            this.incorrectCasingSubmittedValues.push(this.submittedValue);
          }
          if (this.incorrectSpecialCharacters) {
            this.incorrectSpecialCharactersSubmittedValues.push(this.submittedValue);
          }
          if (this.incorrectPunctuation) {
            this.incorrectPunctuationSubmittedValues.push(this.submittedValue);
          }
        }
      }
      if (!this.entryHasUserInput && !this.wordsHaveUserInput) {
        var _exercise$exerciseTyp;
        // For matchText exercises, don't auto-fill entries without a sentence (distractor prompts)
        var isMatchTextWithoutSentence = (exercise === null || exercise === void 0 || (_exercise$exerciseTyp = exercise.exerciseType) === null || _exercise$exerciseTyp === void 0 ? void 0 : _exercise$exerciseTyp.slug) === 'matchText' && !this.exerciseEntry.hasSentence;
        if (!isMatchTextWithoutSentence) {
          this.assignedExerciseEntry = this.exerciseEntry;
          if (this.exerciseEntry.hasSentence) {
            this.submittedValue = this.exerciseEntry.sentence.targetText;
          }
          if (this.exerciseEntry.hasMediaOptions) {
            var selectedMediaOption = this.exerciseEntry.mediaOptions.find(function (item) {
              return item.selected;
            });
            if ((0, _utils.isPresent)(selectedMediaOption)) {
              this.submittedValue = selectedMediaOption.id;
            }
          }
          this.blankValueFilledIn = true;
        }
      }
      this.revealed = true;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$skipSentence = _ref.skipSentence,
        skipSentence = _ref$skipSentence === void 0 ? false : _ref$skipSentence;
      this.assigned = false;
      this.revealed = false;
      this.assignedExerciseEntry = {};
      this.blankValueFilledIn = false;
      this.submittedValue = null;
      this.incorrectCasing = false;
      this.incorrectSpecialCharacters = false;
      this.incorrectPunctuation = false;
      this.incorrectCasingSubmittedValues = [];
      this.incorrectSpecialCharactersSubmittedValues = [];
      this.incorrectPunctuationSubmittedValues = [];
      if (!skipSentence && this.exerciseEntry.hasSentence) {
        this.exerciseEntry.sentence.state.reset();
        if (this.exercise) {
          var wordAssociations = this.exercise.exerciseType.evaluateEntireSentence ? this.exerciseEntry.sentence.wordAssociations : this.exerciseEntry.sentence.selectedWordAssociations;
          (0, _lodash.each)(wordAssociations, function (item) {
            item.state.reset();
          });
        }
      }
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "assignedExerciseEntry", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "blankValueFilledIn", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "revealed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "assigned", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "submittedValue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "incorrectCasing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "incorrectSpecialCharacters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "incorrectPunctuation", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "incorrectCasingSubmittedValues", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "incorrectSpecialCharactersSubmittedValues", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "incorrectPunctuationSubmittedValues", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "correct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "correct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submissionMatches", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "submissionMatches"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submittedValueMatchesMediaOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "submittedValueMatchesMediaOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submittedValueMatchesMultipleChoiceOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "submittedValueMatchesMultipleChoiceOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSelectedWordsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSelectedWordsCorrect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allWordsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allWordsCorrect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submittedValueMatchesAlternateText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "submittedValueMatchesAlternateText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "normalizedSentenceTargetText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedSentenceTargetText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "normalizedSubmittedValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedSubmittedValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submittedValueMatchesSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "submittedValueMatchesSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignedExerciseEntryMatches", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "assignedExerciseEntryMatches"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignedExerciseEntryPrompt", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "assignedExerciseEntryPrompt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "entryHasUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "entryHasUserInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordsHaveUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordsHaveUserInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incorrectCasingSubmittedValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "incorrectCasingSubmittedValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incorrectSpecialCharactersSubmittedValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "incorrectSpecialCharactersSubmittedValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incorrectPunctuationSubmittedValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "incorrectPunctuationSubmittedValue"), _class.prototype), _class);
var _default = exports["default"] = ExerciseEntryState;